<template>
  <div id="container">
      <main id="main" class="nisc-container">
      <div class="inner">
        <!--메인슬라이스-->
        <section class="main-section-01">
          <div class="main-swiper-wrap">
            <div class="swiper" id="main-swiper">
                <div class="main-top__swiper swiper swiper-container">
                  <swiper ref="mainSwiper" class="swiper-wrapper" :options="swiperOption">
                    <swiper-slide v-for="(item, index) in mainSlideList" class="swiper-slide"  :key="`bg0${index+1}`" :style="doSwiperStyle(item)">
                      <a :href="item.img" :title="item.url != null && item.url != ''?(item.newWinYn=='Y'?'새창열림':'화면이동'):''" @focus="slideFocus(swiper, index, $event)"> 
                          <div v-html="$sanitize(item.content)"></div>
                      </a>
                    </swiper-slide>
                  </swiper>

                  <div class="swiper-indicator">
                      <div class="swiper-pagination"></div>
                      <div class="swiper-controller">
                          <button type="button" class="swiper-button-play" v-if="!isPlaying" @click="handlePlayStopButtons">
                              <span class="sr-only">슬라이드 재생</span>
                          </button>
                          <button type="button" class="swiper-button-stop" v-else @click="handlePlayStopButtons">
                              <span class="sr-only">슬라이드 멈춤</span>
                          </button>
                      </div>
                      <div class="swiper-navigation">
                          <button type="button" class="swiper-button-prev" @click="togglePrev()">
                              <span class="sr-only">이전</span>
                          </button>
                          <button type="button" class="swiper-button-next" @click="toggleNext()">
                              <span class="sr-only">다음</span>
                          </button>
                          <a class="swiper-button-more" @click="doSliderLink()">
                              <span class="sr-only">더 보기</span>
                          </a>
                      </div>
                    </div>
                </div>
            </div>
          </div>
        </section>
        <!-- // 메인슬라이스 -->

        <!--공지사항-->
        <section class="main-section-02">
          <h2 class="section-title">
            공지사항
            <a href="javascript:void(0);" @click="doContentLink('M0013', 'M0005')" class="more-btn ico-plus">
              <span class="sr-only">더 보기</span>
            </a>
          </h2>
          <ul class="noti-list grid-3">
            <li v-for="(item, index) in noticeList" :key="`li_${index}`" >
              <h3 class="noti-title curs-p" @click="doBoardMainLink(item)" :title="`화면이동-${item.title}`">
                <a class="truncate">{{item.title}}</a>
              </h3>
              <p class="noti-desc truncate-3">{{$sanitize(item.ctnt,{allowedTags:['aa']})}}</p>
              <time datetime="2025-03-03" class="date">{{item.crtDttm}}</time>

              <div v-if="item.keyword != null && item.keyword != ''" class="noti-tags">
                <a v-for="(tagItem, tagIndex) in doHashtag(item.keyword)" :key="tagIndex" class="noti-tag-txt">#{{tagItem.trim()}}</a>
              </div>   
            </li>
          </ul>
        </section>
        <!--//공지사항-->
        
        <section class="main-section-03">
          <div class="main-biz-category">
            <h2 class="section-title">사업분야</h2>
            <ul class="biz-category grid-3">
                <li v-for="(item, index) in slide1List.slice(0,3)" @click="item.url ? goLink(item) : null" :key="index" class="swiper-slide" :class="{'curs-p': item.url}"  :style="doSwiperStyle(item)">
                    <img :src="item.content" alt="" />
                    <p>{{ item.title }}</p>
                </li>
            </ul>
          </div>
          <div class="main-security-system">
            <h2 class="section-title">정보보안 인증제도 알아보기</h2>
            <div class="security-system__wrap">
              <div class="security-system">
                <h4 class="ss-title">정보보호 국내인증제도</h4>
                <div class="ss-links grid-4">
                  <a v-for="(item, index) in slide2List" :key="index" :href="item.url">
                    <li class="box-link">
                      <img :src="item.imgUrl"/>
                      <span>{{ item.title }}</span>
                    </li>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </main>
	</div>
</template>

<script>
import 'swiper/css/swiper.css'
import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
import { mapGetters } from 'vuex'

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  computed: {
    swiper() {
      return this.$refs.mainSwiper.$swiper;
    },
    swiper2() {
      return this.$refs.swiper2.$swiper;
    },
    swiper3() {
      return this.$refs.swiper3.$swiper;
    },
    ...mapGetters([
      'popupInfo',
    ]),
  },
  data() {
    return {
      isPlaying: true, 
      searchParam: {
        orgCd: null,
      },
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 400,
        loop: true,

        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        pagination: {
            el: ".main-swiper-wrap .swiper-pagination",
            type: "fraction",
        },
      },
      swiperOption2: {
        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: true,
        direction:'horizontal',
        loop: false,
        speed:1000,
      },
      swiperOption3: {
        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: true,
        direction:'horizontal',
        loop: false,
        speed:1000,
      },
      mainPauseClass: 'pause',
      inppzStop: {display: 'inline-block'},
      inppzPlay: {display: 'none'},
      outppzStop: {display: 'inline-block'},
      outppzPlay: {display: 'none'},
      slide1List: [],
      mainSlideList: [],
      topList: [],
      orgList: [],
      orgListPageCnt: 0,
      slide2List: [],
      noticeList: [],  
      photoList: [],
      locationMapClass: 'location-map__wrap',
      orgModalClass: 'modal-wrap mw',
      hashTagList: [],
    }
  },
  created(){
    this.doMain()
  },
  methods: {
    handlePlayStopButtons(){
    if (!this.$refs.mainSwiper) return;

      const swiper = this.$refs.mainSwiper.$swiper;

      if (this.isPlaying) {
        swiper.autoplay.stop();
        this.isPlaying = false;
      } else {
        swiper.autoplay.start();
        this.isPlaying = true;
      }
    },
    togglePrev() {
      this.swiper.slidePrev();
    },
    toggleNext() {
      this.swiper.slideNext();
    },
    doSliderLink(){
      const url = this.mainSlideList[this.swiper.realIndex].url;
      if(url == null || url == ''){
        return ;
      }
      if(url.indexOf(window.location.origin) == 0 || url.indexOf('/') == 0){
        window.location.href = url;
      }else if (url.indexOf('http') == 0){
        window.open(url);
      } else {
        window.open('//'+url);
      }
    },
    doMain() {
      this.$tran('/site/external/main/selectMain', {}).then(response => {
        this.slide1List = response.data.slide1List;
        this.mainSlideList = response.data.mainSlideList;
        this.topList = response.data.topList;
        this.slide2List = response.data.slide2List;
        this.noticeList = response.data.noticeList;
        this.photoList = response.data.photoList;
        this.setMetaInfo();
      })
    },
    doContentLink(menuId, upMenuId) {
      this.$router.push({name:'content', query: {menuId: menuId, upMenuId: upMenuId, s0: null}})
    },
    doBoardMainLink(item) {
      const param = {name:'dynamicDetail', query: {menuId: item.menuId, upMenuId: item.upMenuId, postNo: item.postNo}}
      for(const key in item.queryDepth) {
        param.query[key] = item.queryDepth[key]
      }
      this.$router.push(param)
    },
    doSwiperStyle(item) {
      return {'background-image': `url("${encodeURI(item?.imgUrl)}")`, 'background-size':'cover'}
    },
    // 메타태그
    setMetaInfo() {
      const url = document.location.href;
      const img = '/logo.png';

      const metaInfoData = {
        title: '차세대정보보안인증원',
        ogTitle: '차세대정보보안인증원',
        ogUrl: url,
        ogDescription: '차세대정보보안인증원',
        ogImage: img,
      };
      this.$store.dispatch('setMetaInfo', metaInfoData); 
    },
    doHashtag(keyword){
      if (keyword != null && keyword != ''){
        return keyword.split(',').filter(str => str != '');
      }
    },
    goLink(item) {
    if (item.url && item.url !== "") {
      if (item.newWinYn === "Y") {
        window.open(item.url, "_blank"); // 새창 열기
      } else {
        window.location.href = item.url; // 현재창 이동
      }
    }
  }
  },
}
</script>
